// Layout: Contact page
// 

JLM.MD.PageContact = function( container ) {
	
	const INSTANCE = new JLM.MD.Module();
	
	
	// Variables: Private _______________________________________________________
	
	// References
	let form_contact, form_connect, f_connect_email, f_connect_interests, but_connect_submit;
	
	
	
	// Constructor ______________________________________________________________
	
	function init() {
		// Data fields
		var data_interests = [
			{ label: 'Actors', value: 'actors' },
			{ label: 'Youth Actors', value: 'actors-youth' },
			{ label: 'Voice Actors', value: 'voices' },
			{ label: 'MCs, Speakers & Entertainers', value: 'mcs-entertainers' },
			{ label: 'Presenters', value: 'presenters' },
			{ label: 'Content Creators', value: 'content-creators' },
			{ label: 'Brand Ambassadors', value: 'brand-ambassadors' }
		];
		
		// References (Contact form)
		form_contact = new JLM.MD.FormContact( $('section.contact', container) );
		
		// References (Connect form)
		form_connect = $('#form_connect', container);
		f_connect_email = new JLM.MD.Textfield( $('#f_connect_email', form_connect) );
		f_connect_interests = new JLM.MD.DropdownTags( $('#f_division_interests'), data_interests );
		but_connect_submit = $('button[type="submit"]', form_connect);
		
		// Events
		but_connect_submit.on('click', onConnectSubmit);
		
		// Observed elements
		let observed_elements = [];
		observed_elements.push( $('.wrap > .title', container) );
		observed_elements.push( $('section.contact', container) );
		observed_elements.push( $('section.contact .details', container) );
		observed_elements.push( $('section.connect', container) );
		
		// Observer
		if ( window.IntersectionObserver ) {
			var observer_scroll = new IntersectionObserver(function(entries, observer) {
				entries.forEach(function(entry) {
					if ( entry.isIntersecting ) {
						$(entry.target).addClass('reveal');
						observer_scroll.unobserve(entry.target);
					}
				});
			}, {
				root: null,
				rootMargin: '0px',
				threshold: 0
			});
			observed_elements.forEach(function(element) {
				observer_scroll.observe(element[0]);
			});
		} else {
			observed_elements.forEach(function(element) {
				element.addClass('reveal');
			});
		}
	}
	
	
	
	// Methods: Private _________________________________________________________
	
	// Attempt to submit forms
	// 
	function onConnectSubmit( event ) {
		const form_values = validateConnectForm();
		if (form_values) {
			// Disable form
			disableConnectForm();
			let icon = new JLM.MD.IconLoading(but_connect_submit);
			
			// Get CSRF values
			$.get('/api/tokens/csrf')
				.done(function( response ) {
					// Attach CSRF values
					form_values.csrf_name = response.name;
					form_values.csrf_value = response.value;
					
					// Subscribe
					$.post('/api/newsletter/signup', form_values)
						.done(function( response ) {
							if ( response.success == 1 ) {
								form_connect.addClass('sent');
							} else {
								alert( response.error );
								icon.remove();
								enableConnectForm();
							}
						})
						.fail(function( event ) {
							alert('Message was not sent - failure to connect to server');
							icon.remove();
							enableConnectForm();
						});
				})
				.fail(function( event ) {
					alert('Message was not sent - failure to connect to server');
					icon.remove();
					enableConnectForm();
				});
		}
		
		event.preventDefault();
	}
	
	
	// Form validation
	// 
	function validateConnectForm() {
		let is_valid = true,
			error_fields = [],
			form_values = { email: null, interests: null };
		
		// Name
		form_values.email = $.trim(f_connect_email.value);
		if ( !JLM.MT.isValidEmailAddress( form_values.email ) ) {
			f_connect_email.showError();
			error_fields.push(f_connect_email);
			is_valid = false;
		}
		
		// Interests
		form_values.interests = f_connect_interests.value;
		
		// Response
		if ( is_valid ) {
			return form_values;
		} else if (error_fields.length) {
			error_fields[0].focus(true);
		}
		return is_valid;
	}
	
	
	// Disable/Enable forms
	// 
	function disableConnectForm() {
		f_connect_email.disable();
		$('.label', but_connect_submit).html('&nbsp;');
		$('.icon', but_connect_submit).text('');
		but_connect_submit.prop('disabled', true);
	}
	
	function enableConnectForm() {
		f_connect_email.enable();
		$('.label', but_connect_submit).text('Subscribe');
		$('.icon', but_connect_submit).html('&rarr;');
		but_connect_submit.prop('disabled', false);
	}
	
	
	
	// Initial Setup ____________________________________________________________
	
	init();
	return INSTANCE;
	
};